module.exports = "/_next/static/images/game-2-intro-tutorial-flashlight-3aebaa1ef9a3325d17be8f70b0cd0c65.png";